import React, { useState, Fragment, useEffect } from "react";
import axios from "axios";
import { dateFormatter } from "../../hooks/HelperFunctions";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import ShareRoundedIcon from "@mui/icons-material/ShareRounded";
import Link from "next/link";
import Buttons from "../Button/Button";
import ModalTwo from "../Modals/ModalTwo";
import ShareThisCourse from "../ShareThisCourse/ShareThisCourse";
import ShareThisTrack from "../ShareThisTrack/ShareThisTrack";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import WorkspacePremiumOutlinedIcon from "@mui/icons-material/WorkspacePremiumOutlined";
import Button from "@mui/material/Button";
import styles from "./Tracks.module.css";
import { TrackIcon } from "../../assets/imgs/TrackIcon";
import moment from "moment";
import ModalsResponsiveFullScreen from "../Modals/ModalsResponsiveFullScreen";

function TracksCards(props) {
  const { tracks, showTitle } = props;

  const [open, setOpen] = React.useState(false);
  const [currentTrackData, setCurrentTrackData] = React.useState([]);

  const capitalizeFirstChar = (string) => {
    if (string && string.length > 0) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
    return "";
  };

  const handleOpen = (item) => {
    setCurrentTrackData(item);
    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  const showTheTrackPrice = (item) => {
    let trackPrice = 0;
    item?.terms?.map((term) => {
      term?.courses?.map((course) => {
        trackPrice +=
          course?.course?.priceCat !== "Free" ? course?.course?.price : 0;
      });
    });
    return trackPrice?.toFixed(2);
  };

  return (
    <>
      {tracks?.length > 0 ? (
        <div style={{padding:"0 24px"}}>
          
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={12}>
                {showTitle && <h1>Explore diploma and certificates</h1>}
              </Grid>
              {tracks.map((item, i) => (
                <Grid item xs={12} sm={6} md={4}>
                  <div className={styles.SessionCardContainer}>
                    <div className={styles.SessionCard}>
                      <div className={styles.SessionCardImg}>
                        <Link href={`/track/${item.slug}`}>
                          {item.trackImage ? (
                            <img
                              src={item.trackImage}
                              className="courseCardImg"
                            />
                          ) : (
                            <></>
                          )}
                        </Link>
                      </div>

                      <div className={styles.trackCardbadges}>
                        {item.trackType == "diploma" ? (
                          <div className={styles.trackCardBadgeLabel}>
                            <SchoolOutlinedIcon fontSize="small" />
                            DIPLOMA TRACK
                          </div>
                        ) : (
                          <div className={styles.trackCardBadgeLabel}>
                            <TrackIcon fontSize="small" />
                            {/* <img src={award} alt="icon" /> */}
                            CERTIFICATE TRACK
                          </div>
                        )}
                      </div>

                      <div className={styles.SessionCardInfo}>
                        <div className={styles.SessionCardDate}>
                          <h3>
                            Starts:&nbsp;
                            {item?.terms?.length > 0
                              ? moment(
                                  item?.terms[0]?.sessionStartDate
                                )?.format("ddd, MMM DD, YYYY")
                              : "N/A"}
                          </h3>
                          <span>${showTheTrackPrice(item)}</span>
                        </div>
                        <Link
                          className={styles.TrackCarTitle}
                          href={`/track/${item.slug}`}
                        >
                          <h1>{item.name}</h1>
                        </Link>

                        <div
                          className={`${
                            styles.SessionCardFooter
                          } ${"ButtonGroup"}`}
                        >
                          <div className={styles.ButtonContainer}>
                            <Buttons
                              label={item?.all_courses_bought ? "Go to track" : "Enroll Now"}
                              buttonColor="#004FE0"
                              color="#fff"
                              border=""
                              width="100%"
                              height="48px"
                              fontSize="14px"
                              // disabled={item.courseCardBtn == "disabled"? item.courseCardBtn : ""}
                              link={item?.all_courses_bought ? `my-track-details/${item?.trackId}` : `/track/${item.slug}`}
                              // onClick={addToCartBtnLabel[item.courseId] == "Go to Course"? () => gotoCourseDetails(item.courseId) : (item.price == 'Free' ? () => enrollNowHandler(item) : () => addToCartHandler(item, i)) }
                            />
                          </div>

                          <div className={styles.ShareButton}>
                            <div className={styles.ButtonContainer}>
                              <Buttons
                                icon={<ShareRoundedIcon />}
                                buttonColor="#fff"
                                color="#676C7B"
                                width="48px"
                                height="48px"
                                fontSize="30px"
                                borderRadius="100px"
                                border="#676C7B 1px solid"
                                onClick={() => handleOpen(item)}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Grid>
              ))}
            </Grid>
      

          <ModalsResponsiveFullScreen
            open={open}
            handleClose={handleClose}
            width="552px"
            ModalTitle="Share this track"
            titileColor="#33B651"
            padding="20px"
            body={
              <div className="ModalSocialShare">
                <ShareThisTrack
                  trackDetails={currentTrackData}
                  showTitle={false}
                />
              </div>
            }
          />
        </div>
      ) : (
        ""
      )}
    </>
  );
}

export default TracksCards;
